import { fetchJSON } from '@ratehub/base-ui';

/**
 * Fetch search results from Ratehub API
 * @param {string} apiRoute - API endpoint URL
 * @param {object} options - Search configuration options
 * @param {string} options.query - Search query string
 * @param {number} [options.page=1] - Page number
 * @param {number} [options.perPage=12] - Results per page
 * @returns {Promise<{results: Array, productList: Array}>} - Object containing search results and product list
 */
export default async function fetchSearchResults(apiRoute, options) {
    if (!options?.query) {
        throw new Error('Search query is required');
    }

    const params = {
        query: options.query,
        page: options.page ?? 1,
        perPage: options.perPage ?? 12,
    };

    const content = await fetchJSON({
        url: apiRoute,
        params: params,
    }, 'fetchSearchResults');

    // Search Phase 3: API now returns productList alongside results when a
    // credit-card intent is detected in the query. productList contains
    // matched credit card products grouped by productType.
    // When no credit-card intent is detected, productList is absent from the response.
    return {
        results: content?.data?.results || [],
        productList: content?.data?.productList || [],
    };
}
